import React from "react";
import PropTypes from "prop-types";
import { TabsSwitcherContainer } from "./CompanyDetails.styles";

const TabsSwitcher = ({ tabs, activeTab, onChange, variant = "box" }) => {
  return (
    <TabsSwitcherContainer
      className={variant === "underline" ? "underline" : ""}
    >
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={activeTab === tab.key ? "tab-button active" : "tab-button"}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </TabsSwitcherContainer>
  );
};

TabsSwitcher.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["box", "underline"]),
};

export default TabsSwitcher;
